import React from 'react';
import OlsShopContainer from '../../shop/components/OlsShopContainer';

const ShopContainer = props => (
  <OlsShopContainer
    { ...props }
    productListComponent='ProductList2'
    placeholderListComponent='PlaceholderProductList2'
  />
);

export default ShopContainer;
